import styled from 'styled-components';
import { Flex } from 'rebass';
import { withProps } from 'recompose';
import theme from '../../themes';

export default withProps({
  column: true,
})(styled(Flex)`
  padding: ${theme.space[2]}px 0;
`);



// WEBPACK FOOTER //
// ./src/app/components/input_group/index.js